import { PrimeReactStylesFunctionType } from '../types';
import { classNames } from 'primereact/utils';

export const CheckboxTailwindThemes = {
  checkbox: {
    root: {
      className: classNames('inline-flex relative select-none align-bottom', 'w-4 h-4'),
    },
    input: {
      className: classNames(
        'peer',
        'absolute appearance-none top-0 left-0 size-full p-0 m-0 opacity-0 z-10 outline-none cursor-pointer',
      ),
    },
    box: ({ props, context }: PrimeReactStylesFunctionType) => ({
      className: classNames(
        'flex items-center justify-center',
        'border border-1 w-4 h-4 rounded-[5px] transition-colors duration-200',
        {
          'border-fletchers-gray-200 bg-white peer-hover:border-fletchers-green-900 peer-hover:bg-fletchers-green-50':
            !context.checked,
          'border-fletchers-green-500 bg-fletchers-green-500 peer-hover:border-fletchers-green-900 peer-hover:bg-fletchers-green-900':
            context.checked,
        },
        props.className,
        {
          'outline-transparent peer-focus-visible:outline-2 peer-focus-visible:outline-offset-2 peer-focus-visible:outline-fletchers-green-500':
            !props.disabled,
          'cursor-default opacity-60': props.disabled,
        },
      ),
    }),
    icon: {
      className: classNames('w-4 h-4 transition-all duration-200 text-white text-base'),
    },
  },
};
